<template>
  <div
    class="iconPicker"
  >
    <strong
      v-if="iconPickerData.title"
      class="iconPickerTitle"
    >
      {{ iconPickerData.title.toUpperCase() }}
    </strong>
    <div
      v-for="(icons, rowIndex) in iconPickerData.icons"
      :key="rowIndex"
      class="d-flex"
    >
      <v-btn
        v-for="(icon, columnIndex) in icons"
        :key="columnIndex"
        :icon="getIcon(icon)"
        size="x-small"
        variant="text"
        class="iconOption"
        :class="icon === getSelectedIcon() ? 'selectedOption' : ''"
        :style="{fill: markerIconMap.get(icon)?.hex}"
        :data-testid="`icon-option-${rowIndex}-${columnIndex}`"
        @click="handleIconClick(icon)"
      />
    </div>
  </div>
</template>

<script>
import {IconPickerOptions} from '@/services/GraphicService';
import {markerIconMap, featureIconMap} from '@/services/MapService/Icons';

export default {
  name: 'IconPicker',
  props: {
    iconPickerData: {
      type: IconPickerOptions,
      default: null,
    },
  },
  emits: ['iconChange'],
  data() {
    return {
      /** @type {string} */
      clickedIcon: null,
      markerIconMap,
    };
  },
  watch: {
    iconPickerData: {
      handler() {
        // Whenever the iconPickerData prop updates, reset the locally selected icon
        this.clickedIcon = null;
      },
      deep: true,
    },
  },
  methods: {
    getIcon(icon) {
      return markerIconMap?.get(icon)?.svg ?? featureIconMap.get(icon)?.svg ?? icon;
    },
    /**
     * handles the action when a user clicks a icon on the icon picker.
     * The iconPickerData object has a setIcon function that accepts an icon string.
     * This function calls the callback with the icon chosen on this component
     * @param {string} icon - the icon passed to the callback
     */
    handleIconClick(icon) {
      this.clickedIcon = icon;
      this.iconPickerData.setIcon(icon);
    },
    /**
     * getSelectedIcon - gets the currently selected icon. If there is no selected icon
     * in this component, we need to get the icon from the iconPickerData itself.
     * @return {string} color
     */
    getSelectedIcon() {
      return this.clickedIcon ?? this.iconPickerData.getIcon();
    },
  },
};
</script>

<style lang="scss" scoped>
.iconPicker {
  text-align: left;
}

.iconPickerTitle {
  font-size: 12px;
  color: main.$npGray;
  margin: 4px;
}

.iconOption {
  border-radius: 25px;
  margin-left: -2px;
  margin-right: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: main.$npGray;
  &:hover {
    background-color: lightgray;
  }
}

.selectedOption {
  background-color: lightgray;
}
</style>
